import { useDispatch } from 'react-redux';

import type { AppDispatch } from '#store.config';

const useAppDispatch: () => AppDispatch = useDispatch;

export default useAppDispatch;
